export const BUSINESS_TRIP_TYPE = 'business';
export const COMMUTE_TRIP_TYPE = 'commute';
export const PERSONAL_TRIP_TYPE = 'personal';
export const BUSINESS_COMMUTE_TRIP_TYPE = 'business-commute';
